import { defineNuxtPlugin } from "#app";
import * as Sentry from "@sentry/vue";

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const router = useRouter()

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: config.public.sentryDsn,
    environment: config.public.sentryEnvironment,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.captureConsoleIntegration({ levels: ["error"] }),
      Sentry.replayIntegration(),
    ],
    sampleRate: 0.5,
    tracesSampleRate: 0.5,
    tracePropagationTargets: ["localhost", /^https:\/\/bnpl-staging.instacash.hu\/api/, /^https:\/\/bnpl.instacash.hu\/api/],
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 0.5,
  });
});